import { Button, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledPaper = styled("div")({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "420px",
    height: "250px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    alignItems: "center",
    borderRadius: "3px",
    boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
});

const StyledModalHeader = styled(Typography)({
    alignSelf: "center",
    marginTop: "5%",
});

const StyledModalContainer = styled("div")({
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    width: "90%",
    height: "90%",
});

const StyledCancelAndDeleteButton = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignSelf: "end",
});

const AssetServicesDeleteModal = (props) => {
    const { open, toggleModal, deleteAssetServicesRecord, propertyManagementKey } = props;

    const toggleModalClose = () => {
        toggleModal(false);
    };

    const handleDelete = (propertyManagementKey) => {
        deleteAssetServicesRecord(propertyManagementKey);
        toggleModalClose();
    };

    return (
        <React.Fragment>
            <Modal
                aria-labelledby="asset-services-delete-modal"
                aria-describedby="deletes current asset services record"
                open={open}
                onClose={toggleModalClose}
            >
                <StyledPaper>
                    <StyledModalHeader variant="h5">Delete Asset Services Record?</StyledModalHeader>
                    <StyledModalContainer>
                        <div>
                            Are you sure you want to delete this record?
                            {<br />}
                            Once this record is deleted it cannot be recovered.
                        </div>
                        <CancelAndDeleteButtons
                            toggleModalClose={toggleModalClose}
                            handleDelete={() => handleDelete(propertyManagementKey)}
                        />
                    </StyledModalContainer>
                </StyledPaper>
            </Modal>
        </React.Fragment>
    );
};

const CancelAndDeleteButtons = (props) => {
    const { toggleModalClose, handleDelete } = props;
    return (
        <React.Fragment>
            <StyledCancelAndDeleteButton>
                <Button variant="contained" color="default" onClick={toggleModalClose}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleDelete}>
                    Delete
                </Button>
            </StyledCancelAndDeleteButton>
        </React.Fragment>
    );
};

export default AssetServicesDeleteModal;
